// Temporary code to format item label. It will be removed when RDS is implemented
function numberOfLights (num) {

	return `${num} light${num === '1' ? '' : 's'}`;

}

function height (heightValue) {

	if (heightValue >= 0.5) {

		return `${Math.round(heightValue)}"`;

	}

	return '1"';

}

function getFormattedItemLabel (itemLabel, groupLabel) {

	if (!itemLabel) {

		return '';

	}

	switch (groupLabel) {

		case 'Number of Lights':
			return numberOfLights(itemLabel);
		case 'Height':
			return height(itemLabel);
		default:
			return itemLabel;

	}

}

export default getFormattedItemLabel;
